import { render, staticRenderFns } from "./uploadAvatar.vue?vue&type=template&id=4f448d68&scoped=true"
import script from "./uploadAvatar.vue?vue&type=script&lang=js"
export * from "./uploadAvatar.vue?vue&type=script&lang=js"
import style0 from "./uploadAvatar.vue?vue&type=style&index=0&id=4f448d68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f448d68",
  null
  
)

export default component.exports